import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import logo from '../../../assets/imgs/logo.png';
// import logowhite from '../../../assets/imgs/Xtegrity-white-logo.png';
/**Imported for form validation */
import { useFormik } from 'formik';
import { forgotPasswordInitialValues, forgotPasswordSchema } from '../../../Extras/AuthenticationFormik';
import showToast from '../../../../../Shared/Utils/ToastNotification';
import Service from '../services/Service';
import { useSelector } from 'react-redux';
import img1 from '../../../../../assets/imgs/0a8f62242ec799f152866e747fa102562420968c.png';
import img2 from '../../../../../assets/imgs/0ce5c8b58d533e324615a59d7f991dd3977bd4b3.jpg';
import img3 from '../../../../../assets/imgs/1fe0554d501cb3c912ebad3f44b26392392df6a0.png';
import img4 from '../../../../../assets/imgs/09bdaab1a2034e127e45ce747d211455d4d06b6a.jpg';
import img5 from '../../../../../assets/imgs/8858e91672837f1ec1cf70fb12151be8cfd7f945.jpg';
import brandlogo from '../../../../../assets/imgs/swimscore-logo.png';

const ForgotPassword = () => {
  const loginImages = [img1, img2, img3, img4, img5];

  // Randomly select initial image
  const [currentImageIndex, setCurrentImageIndex] = useState(() => Math.floor(Math.random() * loginImages.length));

  // const navigate = useNavigate();
  const isLoading = useSelector((state) => state.loader.forgotPassword);

  // Rotate images every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % loginImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [loginImages.length]);

  const formik = useFormik({
    initialValues: forgotPasswordInitialValues,
    validationSchema: forgotPasswordSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          email: values.email,
          redirect_url: `${window.location.origin}/reset-password`, //Dynamic base URL
        };
        const response = await Service.forgotPassword(payload);
        if (response.status === 200 && response?.data) {
          showToast('success', response?.data?.detail || 'Password reset link sent to your email');
          // navigate('/reset-password');
        } else {
          showToast('error', response?.data?.detail || 'Failed to send reset link');
        }
      } catch (error) {
        showToast('error', 'Unable to send reset link. Please try again.');
      }
    },
  });

  const error = (name) => (formik.touched[name] && formik.errors[name] ? <div className="error">{formik.errors[name]}</div> : null);
  return (
    <>
      <div className="login">
        <div className="login-content">
          <img className="login-video" src={loginImages[currentImageIndex]} alt="Login background" />
          <div className="logo">
            <img src={brandlogo} alt="" />
          </div>
        </div>
        <div className="login-form loginpage">
          <div className="login-head">
            <h2>Forgot Password</h2>
          </div>

          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="form-group">
              <label>
                Email Address <span className="require">*</span>
              </label>
              <input
                className={`form-control${error('email') ? ' is-invalid' : ''}`}
                type="email"
                name="email"
                placeholder="Cameronwilliamson@gmail.com"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={formik.isSubmitting}
              />
              {error('email')}
            </div>

            <button className="btn" type="submit" disabled={formik.isSubmitting || !formik.isValid || isLoading}>
              {isLoading ? 'Sending...' : 'Send Reset Link'}
              {/* Send Reset Link */}
            </button>

            <div className="login-foot">
              <div className="login-link">
                Remembered your password? <Link to="/">Login</Link>
              </div>
            </div>
          </form>

          {/* <p className="login-bottom-text">Your data is processed securely and handled in line with applicable regulations.</p> */}
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
